module.exports = __webpack_public_path__ + "img/text-box-outline.98b51809.svg";